module.exports = __webpack_public_path__ + "dist/img/head.660940ea.jpg";